import { Grid } from "@mui/material";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { IsBillableSelection } from "./IsBillableSelection";

export const OrderTemplateOtherSettings = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const [otherSettingsOpen, setOtherSettingsOpen] = useState(false);

  return (
    <FormSection
      title={t("customers:orderTemplate:otherSettings")}
      collapse
      open={otherSettingsOpen}
      toggleOpen={() => setOtherSettingsOpen(!otherSettingsOpen)}
    >
      <Grid item xs={3} />
      <Grid item xs={9}>
        <Controller
          name="isBillable"
          control={control}
          render={({ field: { value, onChange: fieldOnChange } }) => (
            <IsBillableSelection
              isBillable={value}
              onIsBillableChange={fieldOnChange}
              tooltipText={t("customers:orderTemplate:notBilledTooltip")}
            />
          )}
        />
      </Grid>
    </FormSection>
  );
};
